import { call, take, put } from 'redux-saga/effects'
import { apiSaga } from './sagas'
import {
  loadDeliveriesForLocation,
  loadDeliveryDropoffById,
} from '../../api/api'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

export const LOAD_DELIVERY_SCHEDULE = 'foodsby/delivery/LOAD_DELIVERY_SCHEDULE'
export const LOAD_DELIVERY_SCHEDULE_SUCCESS =
  'foodsby/delivery/LOAD_DELIVERY_SCHEDULE_SUCCESS'
export const LOAD_DELIVERY_SCHEDULE_FAILURE =
  'foodsby/delivery/LOAD_DELIVERY_SCHEDULE_FAILURE'

export const LOAD_DELIVERY_DROPOFF = 'foodsby/delivery/LOAD_DELIVERY_DROPOFF'
export const LOAD_DELIVERY_DROPOFF_SUCCESS =
  'foodsby/delivery/LOAD_DELIVERY_DROPOFF_SUCCESS'
export const LOAD_DELIVERY_DROPOFF_FAILURE =
  'foodsby/delivery/LOAD_DELIVERY_DROPOFF_FAILURE'

export const SELECT_DELIVERY = 'foodsby/delivery/SELECT_DELIVERY'
export const CLEAR_DELIVERY = 'foodsby/delivery/CLEAR_DELIVERY'

export const loadDeliveryScheduleStart = (locationId, date) => {
  return {
    type: LOAD_DELIVERY_SCHEDULE,
    payload: { locationId, date },
  }
}

export const loadDeliveryScheduleSuccess = deliveryDays => {
  return {
    type: LOAD_DELIVERY_SCHEDULE_SUCCESS,
    payload: { deliveryDays },
  }
}

export const loadDeliveryScheduleFailure = error => {
  return {
    type: LOAD_DELIVERY_SCHEDULE_FAILURE,
    error,
  }
}

export const loadDeliveryDropoffStart = deliveryDropoffId => {
  return {
    type: LOAD_DELIVERY_DROPOFF,
    payload: { deliveryDropoffId },
  }
}

export const loadDeliveryDropoffSuccess = deliveryDropoff => {
  return {
    type: LOAD_DELIVERY_DROPOFF_SUCCESS,
    payload: { deliveryDropoff },
  }
}

export const loadDeliveryDropoffFailure = error => {
  return {
    type: LOAD_DELIVERY_DROPOFF_FAILURE,
    error,
  }
}

export const selectDelivery = delivery => {
  return {
    type: SELECT_DELIVERY,
    payload: { delivery },
  }
}

export const clearDelivery = () => {
  return {
    type: CLEAR_DELIVERY,
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [LOAD_DELIVERY_SCHEDULE]: state => {
    return {
      ...state,
      isLoadingDeliveries: true,
    }
  },
  [LOAD_DELIVERY_SCHEDULE_SUCCESS]: (state, action) => {
    return {
      ...state,
      deliveries: action.payload.deliveryDays[0].deliveries,
      isLoadingDeliveries: false,
      error: undefined,
    }
  },
  [LOAD_DELIVERY_SCHEDULE_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLoadingDeliveries: false,
      error,
    }
  },
  [LOAD_DELIVERY_DROPOFF]: state => {
    return {
      ...state,
      isDeliveryDropoffLoading: true,
      error: undefined,
    }
  },
  [LOAD_DELIVERY_DROPOFF_SUCCESS]: (state, action) => {
    const { deliveryDropoff } = action.payload
    return {
      ...state,
      isDeliveryDropoffLoading: false,
      deliveryDropoff,
      error: undefined,
    }
  },
  [LOAD_DELIVERY_DROPOFF_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isDeliveryDropoffLoading: false,
      deliveryDropoff: undefined,
      error,
    }
  },
  [SELECT_DELIVERY]: (state, action) => {
    const { delivery } = action.payload
    return {
      ...state,
      delivery,
      error: undefined,
    }
  },
  [CLEAR_DELIVERY]: state => {
    return {
      ...state,
      delivery: undefined,
    }
  },
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  deliveries: [],
  isLoadingDeliveries: true,
  deliveryDropoff: {},
}

export default function delivery(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------
export function* watchLoadDeliverySchedule() {
  while (true) {
    const {
      payload: { date, locationId },
    } = yield take(LOAD_DELIVERY_SCHEDULE)
    yield call(
      apiSaga,
      loadDeliveriesForLocation,
      [locationId, date],
      loadDeliveryScheduleSuccess,
      loadDeliveryScheduleFailure,
      undefined,
      true,
    )
  }
}

export function* watchLoadDeliveryDropoff() {
  while (true) {
    try {
      const {
        payload: { deliveryDropoffId },
      } = yield take(LOAD_DELIVERY_DROPOFF)
      yield call(
        apiSaga,
        loadDeliveryDropoffById,
        [deliveryDropoffId],
        loadDeliveryDropoffSuccess,
        loadDeliveryDropoffFailure,
      )
    } catch (error) {
      yield put(loadDeliveryDropoffFailure(error))
    }
  }
}
